module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/st-342a4d3c791c89ec3103cbfbc44496c0.svg";